import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Index from './pages/LandingPage';
// import CoachRegisterForm from './pages/CoachRegisterForm';
import SuccessPage from './pages/SuccessPage';
import CancelPage from './pages/CancelPage';
import CoachRegisterForm from './pages/CoachRegisterForm';
import { Toaster } from 'sonner';


const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster position='top-right' richColors />
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Index />} />
          <Route path='*' element={<Navigate to='/' replace />} />
          <Route path='/coach-register' element={<CoachRegisterForm />} />
          <Route path='/success' element={<SuccessPage />} />
          <Route path='/cancel' element={<CancelPage />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
